import { CustomerRepository } from "../../repositories/CustomerRepository";
import { CustomerGroupEntity } from "../../entities/CustomerEntity";

/**
 * Create Customer Group Use Case
 * Creates a new customer group
 */
export class CreateCustomerGroupUseCase {
  constructor(private repository: CustomerRepository) {}

  async execute(groupData: {
    group_name: string;
    group_description?: string;
  }): Promise<{
    success: boolean;
    message: string;
    data: CustomerGroupEntity;
  }> {
    // Validate group name
    if (!groupData.group_name || groupData.group_name.trim() === "") {
      throw new Error("Group name is required");
    }

    return await this.repository.createCustomerGroup(groupData);
  }
}

